import { Map } from 'immutable';
import { offersHistory } from './types';

import { normalizeIds, normalizeModelList } from '../../utils/Normalizer';

export * from './actions';

const offersHistoryReducersObject = {
  [offersHistory.request]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['offersHistory', 'network', 'error'], false)
        .setIn(['offersHistory', 'network', 'loading'], true),
    ),
  [offersHistory.success]: (state, { matchId, response }) =>
    state.withMutations((currentState) =>
      currentState
        .mergeIn(['offersHistory', 'ids'], normalizeIds(response))
        .mergeIn(['offersHistory', 'byId'], normalizeModelList(response))
        .setIn(
          ['offersHistory', 'groupByFundingMatchId'],
          Map({ [matchId]: normalizeIds(response) }),
        )
        .setIn(['offersHistory', 'network', 'loading'], false)
        .setIn(['offersHistory', 'network', 'error'], false),
    ),
  [offersHistory.failure]: (state, action) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['offersHistory', 'network', 'loading'], false)
        .setIn(['offersHistory', 'network', 'error'], action.error),
    ),
};

export default offersHistoryReducersObject;
